<template>

  <t-page>

    <t-dialog-import type="type-equipment"
                     @onImported="onDialogImported"
                     :new-to="currentPage.name + '-form-new'"
                     disable-duplicate/>

    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage">

      <template #search>

        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                  @click="openDialogForm('modal-import-type-equipment')"
                  primary/>

        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :fields-custom="entityFieldCustomized('page')"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form"/>
      </template>


      <t-table :show="checkViewListTableDefault()" @reload="reloadPageList()"
               :filtered="checkIsFiltered()"
               :busy="!pageListIsLoaded"
               :items="request.content"
               :user-auth="userAuth"
               :fields="userAuth.viewFields"
               primary-key-column="typeEquipmentNumber" link-primary-column="typeEquipmentCodeLabel"/>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import TDialogImport from "@/components/template/dialog/t-dialog-import";
import ui from "@/assets/scripts/ui";

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  components: {TDialogImport},
  name: 'TypeEquipment',
  data() {
    return {
      enableGeneralFields: false,
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    onDialogImported() {

      this.$bvModal.hide('modal-import-type-equipment')
      this.$bvModal.hide('modal-import-models')

      ui.toast(this, 'Sucesso', 'Importação realizada com sucesso!');
      this.getPage(this.pageNumber)

    },

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>

